import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import SecondLayout from "../layouts/SecondLayout";
import BeautyBlogBody from "../components/partials/BeautyBlog/BeautyBlogBody";

const BeautyBlog = () => {
  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "en");

  useEffect(() => {
    window.scrollTo(0, 0);
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "en";
      setLanguage((prev) => (prev !== currentLang ? currentLang : prev));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const pageTitle = language === "ar" ? "مدوّنة الجمال" : "Beauty blog";

  return (
    <SecondLayout>
      <div className="container">
        <h2 className="beauty-blog-title">{pageTitle}</h2>
      </div>
      <BeautyBlogBody language={language} />
      <div className="container my-5">
        <div className="row justify-content-center">
          <img
            src="/assets/images/Beauty/Beauty-Blog-2.jpg"
            className="image-beauty mt-5"
            alt="Beauty-Blog-2"
          />
          <img
            src="/assets/images/Beauty/Beauty-Blog-3.jpg"
            className="image-beauty mt-5"
            alt="Beauty-Blog-3"
          />
          <img
            src="/assets/images/Beauty/Beauty-Blog-4.jpeg"
            className="image-beauty mt-5"
            alt="Beauty-Blog-4"
          />
        </div>
      </div>
    </SecondLayout>
  );
};

export default BeautyBlog;
